var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Heading, Box, AccordionButton, AccordionIcon } from 'shared/components';
/**
 * The header for the Accordion.
 * Pass in a custom icon if you wish (note it must have toggle functionality built in).
 *
 * Note: An <h#> element is necessary for the Accordion API to work. See the Chakra docs.
 * Make sure to include one if you pass a Header prop, or build a custom version of this.
 *
 * See Chakra's Accordion* API here: https://chakra-ui.com/docs/components/disclosure/accordion
 *
 * @param {CollapsibleCardHeaderProps} props CollapsibleCardHeaderProps
 * @returns {React.ReactNode} CollapsibleCardHeader
 */
var CollapsibleCardHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.hideIcon, hideIcon = _b === void 0 ? false : _b;
    return (_jsx("h2", { children: _jsxs(AccordionButton, __assign({ "data-testid": "accordion-button" }, { children: [_jsxs(Box, __assign({ flex: "1", textAlign: "left" }, { children: [_jsx(Heading, __assign({ "data-testid": "header", size: "h3" }, { children: title })), subtitle && (typeof subtitle === 'string' ? _jsx(Text, { children: subtitle }) : subtitle)] })), !hideIcon && _jsx(AccordionIcon, {})] })) }));
};
export { CollapsibleCardHeader };
